<div #bg *ngIf="atLeast2Pages">
  <div #bar></div>
</div>
